let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("18zhh")).then(() => parcelRequire('3WEzz'));